// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full page background with bubbles */
.bubble-background {
    height: 100vh;
    width: 100vw;
    background: #f5f5f5;
    position: relative;
    overflow: hidden;
  }
  
  /* Bubble styling */
  .bubble-background::before,
  .bubble-background::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    opacity: 0.2;
    z-index: -1;
  }
  
  /* Bubble 1 */
  .bubble-background::before {
    width: 120px;
    height: 120px;
    background: gray;
    top: 10%;
    left: 10%;
    animation: float 6s infinite ease-in-out;
  }
  
  /* Bubble 2 */
  .bubble-background::after {
    width: 180px;
    height: 180px;
    background: darkgray;
    bottom: 15%;
    right: 15%;
    animation: float 8s infinite ease-in-out;
  }
  
  /* Bubble animation */
  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-30px);
    }
    100% {
      transform: translateY(0px);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/LoginForm.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;;IAEE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA,aAAa;EACb;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,wCAAwC;EAC1C;;EAEA,aAAa;EACb;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,UAAU;IACV,wCAAwC;EAC1C;;EAEA,qBAAqB;EACrB;IACE;MACE,0BAA0B;IAC5B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,0BAA0B;IAC5B;EACF","sourcesContent":["/* Full page background with bubbles */\r\n.bubble-background {\r\n    height: 100vh;\r\n    width: 100vw;\r\n    background: #f5f5f5;\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  /* Bubble styling */\r\n  .bubble-background::before,\r\n  .bubble-background::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    opacity: 0.2;\r\n    z-index: -1;\r\n  }\r\n  \r\n  /* Bubble 1 */\r\n  .bubble-background::before {\r\n    width: 120px;\r\n    height: 120px;\r\n    background: gray;\r\n    top: 10%;\r\n    left: 10%;\r\n    animation: float 6s infinite ease-in-out;\r\n  }\r\n  \r\n  /* Bubble 2 */\r\n  .bubble-background::after {\r\n    width: 180px;\r\n    height: 180px;\r\n    background: darkgray;\r\n    bottom: 15%;\r\n    right: 15%;\r\n    animation: float 8s infinite ease-in-out;\r\n  }\r\n  \r\n  /* Bubble animation */\r\n  @keyframes float {\r\n    0% {\r\n      transform: translateY(0px);\r\n    }\r\n    50% {\r\n      transform: translateY(-30px);\r\n    }\r\n    100% {\r\n      transform: translateY(0px);\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
